module.exports = __webpack_public_path__ + "img/zanwushuju.25c0dd09.png";